// extracted by mini-css-extract-plugin
export default {"elcontainer":"Card_elcontainer__SuHxS","container":"Card_container__rbLxi"};